import styles from './Loader.module.css';
import styled from "styled-components";

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
`;

const LoaderColor = styled.div`
  border-top-color:#0e3325;
`;

export default function Loader({...rest}){
    return <>
        <LoaderWrapper {...rest}>
            <LoaderColor className={styles.loader}></LoaderColor>
        </LoaderWrapper>
    </>;
}
